import { DEFAULT_HASHTAG_FILTER, PAGES } from "constants/MediaLibrary";
import { useSelector, useDispatch } from "react-redux";
import LegacyTooltip from "../../../../../components/CustomOverlayTrigger/LegacyTooltip";
import OverlayTrigger from "../../../../../components/CustomOverlayTrigger/CustomOverlayTrigger";

import { LOAD_MORE_IG_ASSETS_ROUTINE } from "constants/ActionTypes";

import { getAllMediaLoaded } from "selectors/hashtagFeedSelectors";
import { loadMoreIgAssets } from "actions/sourceMedia";
import { getRoutinesLoading } from "selectors/commonSelectors";
import { Button } from "@/components/ui/button";
import type { ReduxRootState } from "types/redux-store";

interface LoadMoreProps {
  filterState?: typeof DEFAULT_HASHTAG_FILTER;
  page: (typeof PAGES)[keyof typeof PAGES];
}

export function LoadMore({ filterState, page }: LoadMoreProps) {
  const dispatch = useDispatch();
  const isLoadingMore = useSelector((state: ReduxRootState) =>
    getRoutinesLoading(state, [LOAD_MORE_IG_ASSETS_ROUTINE])
  );
  const allMediaLoaded = useSelector((state: ReduxRootState) =>
    getAllMediaLoaded(state, page)
  );

  const tooltipJsx = (
    <LegacyTooltip id="all-media-loaded">
      Showing all posts from within the last 24 hours.
    </LegacyTooltip>
  );

  return (
    <div className="flex flex-col items-center justify-center mt-6 mb-4">
      {allMediaLoaded ? (
        <OverlayTrigger placement="bottom" overlay={tooltipJsx}>
          <p className="font-inter text-sm text-neutral-500 cursor-default">
            All posts loaded
          </p>
        </OverlayTrigger>
      ) : (
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            if (!isLoadingMore) {
              dispatch(loadMoreIgAssets(filterState));
            }
          }}
          disabled={isLoadingMore}
          className="border-neutral-200 hover:border-neutral-300"
        >
          {isLoadingMore ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500 mr-2"></div>
              Loading...
            </>
          ) : (
            "Load More"
          )}
        </Button>
      )}
    </div>
  );
}
